import React, { useState } from 'react'
import { Formik } from 'formik'
import { Wrapper, TextFieldIcon, SelectFieldIcon, Panel, PhoneFieldIcon } from '../../_components'
import * as Yup from 'yup'
import  Axios  from 'axios'
// import { formatPhoneNumber } from '../../_utils'

// const validationSchema = Yup.object().shape( {
//   nin: Yup.string().required( "NIN is Required" ),
//   first_name: Yup.string().required( "First Name is Required" ),
//   last_name: Yup.string().required( "Last Name is Required" ),
//   district: Yup.string().required( "District is Required" ),
//   subcounty: Yup.string().required( "Subcounty is Required" ),
//   parish: Yup.string().required( "Parish is Required" ),
//   village: Yup.string().required( "Village is Required" ),
//   // primary_contact: Yup.string().required( "Phone Number is Required" ),
//   secondary_contact: Yup.string(),
//   co_phone: Yup.string(),
//   nok_firstname: Yup.string().required( "Field is Required" ),
//   nok_lastname: Yup.string().required( "Field is Required" ),
//   nok_other: Yup.string(),
//   // nok_phone: Yup.string().required( "Field is Required" ),
//   relationship: Yup.string().required( "Field is Required" ),
//   birthyear: Yup.string().required( "Field is Required" ),
//   sex: Yup.string().required( "Field is Required" ),
//   gender: Yup.string().required( "Field is Required" ),
//   pwd: Yup.string(),
//   youth: Yup.string(),
//   block_number: Yup.string().required( "Block Number is Required" ),
//   ffs_code: Yup.string().required( "FFSG Number / Name is Required" ),
//   leader: Yup.string().required( "Field is Required" )
// } )

export default function() {
  const [ phone, setPhone ] = useState("") 

  const handleSubmit = async ( values ) => {
    try {
       const response = await Axios.post(`https://mis.nec.go.ug/api/auth/fiefoc_user`, { ...values, name: `${values.first_name} ${values.last_name}`, phone } )
       if( response.data ) {
        alert( response.data.message )
        localStorage.setItem( "name", "view_users" )
        window.location.reload()
       }
    } catch (error) {
        alert( "Server error occured" )
    }
    // try {
    //   const response = await Axios.post( `https://mis.nec.go.ug/api/auth/farmer`, 
    //     { ...values, 
    //       primary_contact: phoneNumber,
    //       secondary_contact: secondaryPhone,
    //       co_phone: coPhone
    //     } 
    //   )
    //   if( response.data ){
    //     alert( "Farmer has been added successfully." )
    //     await localStorage.setItem( "name", "view_farmers" )
    //     window.location.reload()
    //   }
    // } catch (error) {
    //   alert( "An error occured on the server." )
    // }
  }

  return (
    <Wrapper>
      <div>
        <h2 className="text-base">
          {`Add A New User`}
        </h2>
      </div>
      <Formik initialValues={{
        email_address: "",
        password: "",
        organisation: "",
        first_name: "",
        last_name: "",
        role: "",
        gender: "",
        status: "active",
        position: ""
      }}
      onSubmit={handleSubmit}>
      { ( { values, errors, handleBlur, handleChange, handleSubmit } ) => {
          return (
          <form onSubmit={handleSubmit}>
            <Panel label="Add A New User">
                <div className="grid grid-cols-3 gap-3">
                    <TextFieldIcon 
                        type="email"
                        name="email_address"
                        handleChange={handleChange} 
                        handleBlur={handleBlur}
                        value={values.email_address}
                        label="Email Address"
                        required={true}
                        question="Email Address"
                    />

                    <TextFieldIcon 
                        name="password"
                        handleChange={handleChange} 
                        handleBlur={handleBlur}
                        value={values.password}
                        label="Password"
                        required={true}
                        question="Password"
                    />

                    <TextFieldIcon 
                        name="organisation"
                        handleChange={handleChange} 
                        handleBlur={handleBlur}
                        value={values.organisation}
                        label="Organisation"
                        required={true}
                        question="Organisation"
                    />

                    <SelectFieldIcon 
                        name="role"
                        handleChange={handleChange} 
                        handleBlur={handleBlur}
                        value={values.role}
                        label="Role"
                        required={true}
                        question="Role" 
                        options={[ 
                            { id: 1, label: "Admin", value: "Admin" },
                            { id: 2, label: "Leader", value: "Leader" },
                            { id: 3, label: "Farmer", value: "Farmer" } 
                        ]}
                    />

                    <SelectFieldIcon 
                        name="gender"
                        handleChange={handleChange} 
                        handleBlur={handleBlur}
                        value={values.gender}
                        label="Gender"
                        required={true}
                        question="Gender" 
                        options={[ 
                            { id: 1, label: "Male", value: "Male" },
                            { id: 2, label: "Female", value: "Female" },
                        ]}
                    />
                    <div />

                    <TextFieldIcon 
                        name="first_name"
                        handleChange={handleChange} 
                        handleBlur={handleBlur}
                        value={values.first_name}
                        label="First Name"
                        required={false}
                        question="First Name"
                    />

                    <TextFieldIcon 
                        name="last_name"
                        handleChange={handleChange} 
                        handleBlur={handleBlur}
                        value={values.last_name}
                        label="Last Name"
                        required={false}
                        question="Last Name"
                    />

                    <PhoneFieldIcon 
                        name="phone_number"
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        callback={ ( phone ) => {
                            setPhone( phone )
                        } }
                        question="Phone Number"
                    />

                    <TextFieldIcon 
                        name="position"
                        handleChange={handleChange} 
                        handleBlur={handleBlur}
                        value={values.position}
                        label="Position"
                        required={true}
                        question="Position"
                    />
                </div>
            </Panel>
            <button type="submit" className="bg-green-700 px-5 py-2 mx-2 text-white text-sm rounded-sm">
            {`Submit`}
            </button>
          </form>
          )
      } }
      </Formik>
    </Wrapper>
    
  )
    }
